import { render } from "./markDown.vue?vue&type=template&id=50f0492d&scoped=true"
import script from "./markDown.vue?vue&type=script&lang=js"
export * from "./markDown.vue?vue&type=script&lang=js"

import "./markDown.vue?vue&type=style&index=0&id=50f0492d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/blog/blog/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f0492d"]])

export default __exports__